var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    {
      staticClass: "w-100 segment-picker",
      attrs: {
        placeholder: _vm.$t("chatbotv2.chooseASegment"),
        notFoundContent: _vm.$t("chatbotv2.noSegmentFound"),
        size: "large",
        "show-search": "",
        "filter-option": false,
      },
      on: {
        change: _vm.handleChange,
        search: _vm.handleSearch,
        select: _vm.handleSelect,
      },
      model: {
        value: _vm.selectedSegmentId,
        callback: function ($$v) {
          _vm.selectedSegmentId = $$v
        },
        expression: "selectedSegmentId",
      },
    },
    [
      _vm.loading
        ? _c("a-select-option", { key: "loading" }, [
            _vm._v(" " + _vm._s(_vm.$t("chatbotv2.loading")) + " ...."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.getFilteredResult(), function (segment, index) {
        return _c(
          "a-select-option",
          { key: index, attrs: { value: segment._id } },
          [
            _c("div", { staticClass: "item-container" }, [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "logo-container" },
                  [
                    _c(
                      "a-avatar",
                      {
                        staticClass: "avatar",
                        style:
                          "background-color:" +
                          (index % 2 === 0 ? "#c980a3" : "#6899c1"),
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(segment.name.slice(0, 2).toUpperCase()) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _vm._v(_vm._s(segment.name)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "users" }, [
                _vm._v(
                  _vm._s(segment.users.length) +
                    " " +
                    _vm._s(_vm.$t("chatbotv2.users"))
                ),
              ]),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }